import { DealerID } from "./Dealer";

export type DealerReportThresholdID = number;

export enum REPORT_COLUMN_TYPES {
  Number = 1
}

export enum DEALER_REPORT_COLUMNSS {
  WOHandled = 1,
  CheckAanname = 2,
  CheckCommercial = 3,
  CheckMedia = 4,
  CheckCount = 5,
  StatusQuality = 6,
  CCExtraServices = 7
}

export interface DealerReportThreshold {
  created_on: string;
  updated_on: string;
  id: DealerReportThresholdID;
  dealer_id: DealerID; // Dealer Identifier
  dealer_report_column: DEALER_REPORT_COLUMNSS; // The column the threshold is for
  report_column_type: REPORT_COLUMN_TYPES; // The type of column for the threshold to apply. ex: some columns have percent or numbers
  high_value: number | null; // The highest threshold to apply
  low_value: number | null; // The lowest threshold to apply
}
